<template>
  <v-container>

    <h4 class="align-left pa-2 section-title">{{ currentRouteName }}</h4>
<v-card>
  <v-card-text>
    <v-row>
      <v-col class="text-left">
        mobivention GmbH<br/>
        Gottfried-Hagen-Str. 24<br/>
        51105 Köln
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-left">
        Geschäftsführer:<br/>
        Dr. Hubert Weid
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-left">
        Amtsgericht Köln<br/>
        Handelsregister Nr. HRB 51243
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-left">
        Ust.-ID: DE227435786
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-left">
        Tel: 0221-677811-0<br/>
        Fax: 0221-677811-99<br/>
        Mail: <a href="mailto:info@mobivention.com">info(at)mobivention.com</a><br/>
        Web: <a href="https://mobivention.com" target="_blank">https://mobivention.com</a>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-left">
        Inhaltlich verantwortlich im Sinne des § 55 Abs. 2 RStV: Dr. Hubert Weid, Anschrift wie vor.
      </v-col>
    </v-row>


  </v-card-text>
</v-card>
  </v-container>
</template>

<script>
import RouteInfo from "@/utils/RouteInfo";
export default {
  extends: RouteInfo,
  name: "Imprint"
}
</script>

<style scoped>

</style>